import { render } from "./AddBonCommandeFournisseur.vue?vue&type=template&id=1a4c2df3&scoped=true&ts=true"
import script from "./AddBonCommandeFournisseur.vue?vue&type=script&lang=ts"
export * from "./AddBonCommandeFournisseur.vue?vue&type=script&lang=ts"

import "./AddBonCommandeFournisseur.vue?vue&type=style&index=0&id=1a4c2df3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4c2df3"]])

export default __exports__